<template>
  <div v-if="visible" class="disconnect-policy-overlay">
    <div class="disconnect-policy-content">
      <span v-if="text" class="disconnect-policy-text">{{ text }}</span>
      <img v-if="imageUrl" :src="imageUrl" crossorigin="anonymous"  alt=""/>
    </div>
  </div>
  <img id="offline-img" alt="" v-if="imageUrl" :src="imageUrl" crossorigin="anonymous" height="0" width="0"/>
</template>

<script setup lang="ts">
import {computed} from "vue";
import useStore from "../store.ts";

const store = useStore();

const visible = computed(() => store.disconnectPolicyDisplay.visible);
const text = computed(() => store.disconnectPolicyDisplay.text);
// see docs/EXTRACTED_COMMENTS.md#c051
const imageUrl = computed(() => store.disconnectPolicyDisplay.image_url);
</script>

<style scoped>
.disconnect-policy-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.disconnect-policy-content {
  max-width: 80vw;
  padding: 24px 32px;
  color: #ffffff;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  font-weight: 600;
  font-size: 50pt;
  line-height: 1.35;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
  background: #000000;
  border-radius: .25em;
  overflow: hidden;
}

.disconnect-policy-content img {
  position: absolute;
  width: auto;
  height: 100vh;
  display: block;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.disconnect-policy-text {
  white-space: pre-wrap;
}
</style>
